module.exports = __webpack_public_path__ + "static/EnmTX_BosHeathcote_L_A_cl-04714d04b1940b4e3e263c270634fb12.gif";